
export const ListOffer  = [
{text: 'santé/mobilité', value: 'health/mobility'},
{text: 'habitation', value: 'home'},
{text: 'multimédia', value: 'multimedia'},
{text: 'mutuelle santé', value: 'mutual'}
]